import { kMaxUploadSize_bytes } from "@/shared/upload-url.api";
import { bytesToDisplayMB } from "@/shared/utils/fileSize";

/**
 * Why a file a person picked or dropped cannot be taken, if it cannot: the
 * server stages nothing larger, so it would load and play and then fail on
 * the first generation. Checked where the file comes in, not in core
 * `addFiles`, which also stores what a capability generated and returned —
 * that audio is already on the server's side of the cap.
 */
export const getUploadSizeError = (file: File): string | undefined =>
    file.size > kMaxUploadSize_bytes
        ? `${file.name} is larger than ${bytesToDisplayMB(kMaxUploadSize_bytes, 0)}`
        : undefined;
